import { render, staticRenderFns } from "./GroupDetailsTab.vue?vue&type=template&id=6e5ab9b0&scoped=true&"
import script from "./GroupDetailsTab.vue?vue&type=script&lang=js&"
export * from "./GroupDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5ab9b0",
  null
  
)

export default component.exports